import React from 'react';
import { Route } from 'react-router-dom';
import { SentryRoutes } from '@dealstack/frontend/shared/sentry';
import { HelpBlogPage } from '@dealstack/frontend/app/pages/HelpBlog/HelpBlogPage/HelpBlogPage.tsx';
import { ArticlePage } from '@dealstack/frontend/app/pages/HelpBlog/ArticlePage/ArticlePage.tsx';
import { CategoryPage } from '@dealstack/frontend/app/pages/HelpBlog/CategoryPage/CategoryPage.tsx';
import { AuthorPage } from '@dealstack/frontend/app/pages/HelpBlog/AuthorPage/AuthorPage.tsx';
import {
	BreadcrumbsProvider,
	useBreadcrumbs,
} from '@dealstack/frontend/shared/components/Breadcrumbs/useBreadcrumbs.tsx';
import {
	useTranslationCommonUi,
	useTranslationHelpBlog,
} from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks.tsx';
import { CategoriesPage } from './CategoriesPage/CategoriesPage';
import { AuthorsPage } from '@dealstack/frontend/app/pages/HelpBlog/AuthorsPage/AuthorsPage.tsx';
import { HelpBlogContext, useHelpBlogController } from './useHelpBlogController';
import { HELP_BLOG_ROUTES } from '@dealstack/frontend/shared/shared-routes.ts';
import { makeDealPageBreadcrumbs } from '@dealstack/frontend/shared/components/Breadcrumbs/dealBreadcrumbs.utils.tsx';
import { useDealController } from '@dealstack/frontend/app/pages/Project/DealDashboard/useDealController.tsx';
import { ApplicationType } from '@dealstack/shared/lib/generated';

interface Props {
	dataset: ApplicationType;
}

export const HelpBlogBase = ({ dataset }: Props) => {
	const helpBlogController = useHelpBlogController(dataset);

	return (
		<HelpBlogContext.Provider value={helpBlogController}>
			<BreadcrumbsProvider>
				<SentryRoutes>
					<Route path={HELP_BLOG_ROUTES.CATEGORIES} element={<CategoriesPage />} />
					<Route path={HELP_BLOG_ROUTES.AUTHORS} element={<AuthorsPage />} />
					<Route path={HELP_BLOG_ROUTES.CATEGORY} element={<CategoryPage />} />
					<Route path={HELP_BLOG_ROUTES.AUTHOR} element={<AuthorPage />} />
					<Route path={HELP_BLOG_ROUTES.ARTICLE} element={<ArticlePage />} />
					<Route path="/" element={<HelpBlogPage />} />
				</SentryRoutes>
			</BreadcrumbsProvider>
		</HelpBlogContext.Provider>
	);
};

export const HelpBlogWithDeals = ({ dataset }: Props) => {
	const tHelpBlog = useTranslationHelpBlog();
	const tCommonUi = useTranslationCommonUi();
	const { dealId, deals } = useDealController();

	const selectDealName = tHelpBlog('breadcrumbs.selectDeal');

	useBreadcrumbs(
		dataset === ApplicationType.DEALSTACK
			? makeDealPageBreadcrumbs({
					dropdownPlaceholder: selectDealName,
					dealId,
					deals,
					tCommonUi,
				})
			: [],
		{ skipFirst: true }
	);

	return <HelpBlogBase dataset={dataset} />;
};
